var _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 380,
    viewBox: "0 0 380 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 190,
    r: 128.929,
    fill: "#4D7C79",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 190,
    r: 154.714,
    fill: "#4D7C79",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 190,
    r: 190,
    fill: "#4D7C79",
    fillOpacity: 0.04
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.791 82.5149C187.534 79.2509 194.101 79.2509 198.843 82.5149L268.16 118.056V250.43H213.801L179.873 301.204V261.673L202.127 228.67H246.271V131.838L190.817 103.55L135.364 131.838V228.67H179.508V250.793H113.11V118.419L182.791 82.5149Z",
    fill: "#8E849D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_8452_445316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.02,
    y: 290.377,
    width: 32.2641,
    height: 32.2641,
    rx: 16.1321,
    fill: "#ECAE52",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.395,
    y: 290.752,
    width: 31.5141,
    height: 31.5141,
    rx: 15.7571,
    stroke: "url(#paint0_linear_8452_445316)",
    strokeOpacity: 0.2,
    strokeWidth: 0.75,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.339 300.885H252.526V300.322C252.525 299.875 252.346 299.447 252.03 299.131C251.714 298.815 251.286 298.636 250.839 298.635H247.464C247.017 298.636 246.589 298.815 246.273 299.131C245.957 299.447 245.778 299.875 245.776 300.322V300.885H242.964C242.815 300.885 242.672 300.944 242.566 301.049C242.461 301.155 242.401 301.298 242.401 301.447C242.401 301.596 242.461 301.739 242.566 301.845C242.672 301.95 242.815 302.01 242.964 302.01H243.526V312.135C243.526 312.433 243.645 312.719 243.856 312.93C244.067 313.141 244.353 313.26 244.651 313.26H253.651C253.95 313.26 254.236 313.141 254.447 312.93C254.658 312.719 254.776 312.433 254.776 312.135V302.01H255.339C255.488 302.01 255.631 301.95 255.737 301.845C255.842 301.739 255.901 301.596 255.901 301.447C255.901 301.298 255.842 301.155 255.737 301.049C255.631 300.944 255.488 300.885 255.339 300.885ZM248.026 309.322C248.026 309.471 247.967 309.614 247.862 309.72C247.756 309.825 247.613 309.885 247.464 309.885C247.315 309.885 247.172 309.825 247.066 309.72C246.961 309.614 246.901 309.471 246.901 309.322V304.822C246.901 304.673 246.961 304.53 247.066 304.424C247.172 304.319 247.315 304.26 247.464 304.26C247.613 304.26 247.756 304.319 247.862 304.424C247.967 304.53 248.026 304.673 248.026 304.822V309.322ZM251.401 309.322C251.401 309.471 251.342 309.614 251.237 309.72C251.131 309.825 250.988 309.885 250.839 309.885C250.69 309.885 250.547 309.825 250.441 309.72C250.336 309.614 250.276 309.471 250.276 309.322V304.822C250.276 304.673 250.336 304.53 250.441 304.424C250.547 304.319 250.69 304.26 250.839 304.26C250.988 304.26 251.131 304.319 251.237 304.424C251.342 304.53 251.401 304.673 251.401 304.822V309.322ZM251.401 300.885H246.901V300.322C246.901 300.173 246.961 300.03 247.066 299.924C247.172 299.819 247.315 299.76 247.464 299.76H250.839C250.988 299.76 251.131 299.819 251.237 299.924C251.342 300.03 251.401 300.173 251.401 300.322V300.885Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_8452_445316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.726,
    y: 206.132,
    width: 51.9811,
    height: 51.9811,
    rx: 25.9906,
    fill: "#52D0EC",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.33,
    y: 206.736,
    width: 50.7728,
    height: 50.7728,
    rx: 25.3864,
    stroke: "url(#paint1_linear_8452_445316)",
    strokeOpacity: 0.2,
    strokeWidth: 1.20833,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.404 230.31H316.181L313.032 223.23C312.891 222.909 312.659 222.636 312.365 222.445C312.071 222.254 311.728 222.153 311.378 222.154H298.056C297.705 222.153 297.362 222.254 297.068 222.445C296.775 222.636 296.543 222.909 296.402 223.23L293.253 230.31H292.029C291.789 230.31 291.558 230.406 291.388 230.576C291.219 230.745 291.123 230.976 291.123 231.216C291.123 231.457 291.219 231.687 291.388 231.857C291.558 232.027 291.789 232.123 292.029 232.123H292.936V241.185C292.936 241.666 293.127 242.127 293.466 242.467C293.806 242.807 294.267 242.998 294.748 242.998H297.467C297.948 242.998 298.409 242.807 298.748 242.467C299.088 242.127 299.279 241.666 299.279 241.185V239.373H310.154V241.185C310.154 241.666 310.345 242.127 310.685 242.467C311.025 242.807 311.486 242.998 311.967 242.998H314.686C315.166 242.998 315.627 242.807 315.967 242.467C316.307 242.127 316.498 241.666 316.498 241.185V232.123H317.404C317.645 232.123 317.875 232.027 318.045 231.857C318.215 231.687 318.311 231.457 318.311 231.216C318.311 230.976 318.215 230.745 318.045 230.576C317.875 230.406 317.645 230.31 317.404 230.31ZM299.279 235.748H297.467C297.226 235.748 296.996 235.652 296.826 235.482C296.656 235.312 296.561 235.082 296.561 234.841C296.561 234.601 296.656 234.37 296.826 234.201C296.996 234.031 297.226 233.935 297.467 233.935H299.279C299.52 233.935 299.75 234.031 299.92 234.201C300.09 234.37 300.186 234.601 300.186 234.841C300.186 235.082 300.09 235.312 299.92 235.482C299.75 235.652 299.52 235.748 299.279 235.748ZM310.154 235.748C309.914 235.748 309.683 235.652 309.513 235.482C309.344 235.312 309.248 235.082 309.248 234.841C309.248 234.601 309.344 234.37 309.513 234.201C309.683 234.031 309.914 233.935 310.154 233.935H311.967C312.207 233.935 312.438 234.031 312.608 234.201C312.778 234.37 312.873 234.601 312.873 234.841C312.873 235.082 312.778 235.312 312.608 235.482C312.438 235.652 312.207 235.748 311.967 235.748H310.154Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_8452_445316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.293,
    y: 225.768,
    width: 34.0566,
    height: 34.0566,
    rx: 17.0283,
    fill: "#9D5DCF",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6888,
    y: 226.164,
    width: 33.2649,
    height: 33.2649,
    rx: 16.6325,
    stroke: "url(#paint2_linear_8452_445316)",
    strokeOpacity: 0.2,
    strokeWidth: 0.791667,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2979 245.053L69.817 243.568C69.6374 243.488 69.4402 243.455 69.2441 243.471C69.048 243.488 68.8595 243.555 68.6963 243.665L66.8334 244.904C65.698 244.353 64.7788 243.439 64.2209 242.307L65.4529 240.422C65.5622 240.258 65.629 240.07 65.6471 239.874C65.6652 239.679 65.6342 239.482 65.5568 239.301L64.065 235.82C63.9609 235.585 63.7847 235.389 63.5618 235.261C63.339 235.133 63.0811 235.079 62.8256 235.107C61.8233 235.239 60.9029 235.73 60.2353 236.489C59.5677 237.248 59.1985 238.223 59.1963 239.234C59.1963 245.127 63.9908 249.922 69.8838 249.922C70.8946 249.919 71.8702 249.55 72.6292 248.883C73.3883 248.215 73.8791 247.294 74.0104 246.292C74.0387 246.037 73.9849 245.779 73.8568 245.556C73.7287 245.333 73.5329 245.157 73.2979 245.053Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd_8452_445316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.661,
    y: 110.236,
    width: 43.0189,
    height: 43.0189,
    rx: 21.5094,
    fill: "#5DCFAD",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.161,
    y: 110.736,
    width: 42.0189,
    height: 42.0189,
    rx: 21.0094,
    stroke: "url(#paint3_linear_8452_445316)",
    strokeOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.42 139.245C303.42 139.444 303.341 139.635 303.2 139.776C303.06 139.916 302.869 139.995 302.67 139.995H281.67C281.471 139.995 281.28 139.916 281.14 139.776C280.999 139.635 280.92 139.444 280.92 139.245C280.92 139.047 280.999 138.856 281.14 138.715C281.28 138.574 281.471 138.495 281.67 138.495H302.67C302.869 138.495 303.06 138.574 303.2 138.715C303.341 138.856 303.42 139.047 303.42 139.245ZM281.698 128.952C281.653 128.795 281.661 128.627 281.72 128.475C281.78 128.322 281.887 128.194 282.026 128.108L291.776 122.108C291.894 122.034 292.031 121.995 292.17 121.995C292.309 121.995 292.446 122.034 292.564 122.108L302.314 128.108C302.452 128.194 302.559 128.322 302.618 128.474C302.677 128.626 302.685 128.793 302.64 128.95C302.596 129.107 302.501 129.245 302.371 129.343C302.241 129.442 302.083 129.495 301.92 129.495H299.67V135.495H301.17C301.369 135.495 301.56 135.574 301.7 135.715C301.841 135.856 301.92 136.047 301.92 136.245C301.92 136.444 301.841 136.635 301.7 136.776C301.56 136.916 301.369 136.995 301.17 136.995H283.17C282.971 136.995 282.78 136.916 282.64 136.776C282.499 136.635 282.42 136.444 282.42 136.245C282.42 136.047 282.499 135.856 282.64 135.715C282.78 135.574 282.971 135.495 283.17 135.495H284.67V129.495H282.42C282.257 129.496 282.098 129.443 281.968 129.345C281.838 129.246 281.743 129.109 281.698 128.952ZM293.67 134.745C293.67 134.944 293.749 135.135 293.89 135.276C294.03 135.416 294.221 135.495 294.42 135.495C294.619 135.495 294.81 135.416 294.95 135.276C295.091 135.135 295.17 134.944 295.17 134.745V130.245C295.17 130.047 295.091 129.856 294.95 129.715C294.81 129.574 294.619 129.495 294.42 129.495C294.221 129.495 294.03 129.574 293.89 129.715C293.749 129.856 293.67 130.047 293.67 130.245V134.745ZM289.17 134.745C289.17 134.944 289.249 135.135 289.39 135.276C289.53 135.416 289.721 135.495 289.92 135.495C290.119 135.495 290.31 135.416 290.45 135.276C290.591 135.135 290.67 134.944 290.67 134.745V130.245C290.67 130.047 290.591 129.856 290.45 129.715C290.31 129.574 290.119 129.495 289.92 129.495C289.721 129.495 289.53 129.574 289.39 129.715C289.249 129.856 289.17 130.047 289.17 130.245V134.745Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bd_8452_445316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.396,
    y: 62.7358,
    width: 32.2641,
    height: 32.2641,
    rx: 16.1321,
    fill: "#EC5293",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.771,
    y: 63.1108,
    width: 31.5141,
    height: 31.5141,
    rx: 15.7571,
    stroke: "url(#paint4_linear_8452_445316)",
    strokeOpacity: 0.2,
    strokeWidth: 0.75,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.59 72.1179H257.038C256.723 71.7638 256.336 71.4804 255.903 71.2863C255.471 71.0923 255.002 70.9919 254.528 70.9919C254.054 70.9919 253.585 71.0923 253.152 71.2863C252.72 71.4804 252.333 71.7638 252.018 72.1179H249.465C249.167 72.1179 248.881 72.2365 248.67 72.4474C248.459 72.6584 248.34 72.9446 248.34 73.2429V85.0554C248.34 85.3538 248.459 85.6399 248.67 85.8509C248.881 86.0619 249.167 86.1804 249.465 86.1804H259.59C259.889 86.1804 260.175 86.0619 260.386 85.8509C260.597 85.6399 260.715 85.3538 260.715 85.0554V73.2429C260.715 72.9446 260.597 72.6584 260.386 72.4474C260.175 72.2365 259.889 72.1179 259.59 72.1179ZM254.528 72.1179C255.124 72.1198 255.695 72.3574 256.117 72.779C256.538 73.2005 256.776 73.7718 256.778 74.3679H252.278C252.28 73.7718 252.517 73.2005 252.939 72.779C253.36 72.3574 253.932 72.1198 254.528 72.1179ZM256.778 81.1179H252.278C252.129 81.1179 251.986 81.0587 251.88 80.9532C251.775 80.8477 251.715 80.7046 251.715 80.5554C251.715 80.4062 251.775 80.2632 251.88 80.1577C251.986 80.0522 252.129 79.9929 252.278 79.9929H256.778C256.927 79.9929 257.07 80.0522 257.176 80.1577C257.281 80.2632 257.34 80.4062 257.34 80.5554C257.34 80.7046 257.281 80.8477 257.176 80.9532C257.07 81.0587 256.927 81.1179 256.778 81.1179ZM256.778 78.8679H252.278C252.129 78.8679 251.986 78.8087 251.88 78.7032C251.775 78.5977 251.715 78.4546 251.715 78.3054C251.715 78.1562 251.775 78.0132 251.88 77.9077C251.986 77.8022 252.129 77.7429 252.278 77.7429H256.778C256.927 77.7429 257.07 77.8022 257.176 77.9077C257.281 78.0132 257.34 78.1562 257.34 78.3054C257.34 78.4546 257.281 78.5977 257.176 78.7032C257.07 78.8087 256.927 78.8679 256.778 78.8679Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bd_8452_445316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.3364,
    y: 147.275,
    width: 53.7736,
    height: 53.7736,
    rx: 26.8868,
    fill: "#5DCF71",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.9614,
    y: 147.9,
    width: 52.5236,
    height: 52.5236,
    rx: 26.2618,
    stroke: "url(#paint5_linear_8452_445316)",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.864 171.314L78.489 162.794C78.1434 162.478 77.6919 162.303 77.2234 162.303C76.7549 162.303 76.3034 162.478 75.9578 162.794L66.5828 171.314C66.3908 171.489 66.2375 171.703 66.1326 171.941C66.0277 172.179 65.9735 172.437 65.9734 172.697V183.49C65.9658 183.962 66.1327 184.421 66.4421 184.779C66.6178 184.978 66.8342 185.138 67.0767 185.247C67.3193 185.357 67.5824 185.413 67.8484 185.412H73.4734C73.722 185.412 73.9605 185.313 74.1363 185.137C74.3121 184.961 74.4109 184.723 74.4109 184.474V178.849C74.4109 178.6 74.5097 178.362 74.6855 178.186C74.8613 178.01 75.0998 177.912 75.3484 177.912H79.0984C79.347 177.912 79.5855 178.01 79.7613 178.186C79.9371 178.362 80.0359 178.6 80.0359 178.849V184.474C80.0359 184.723 80.1347 184.961 80.3105 185.137C80.4863 185.313 80.7248 185.412 80.9734 185.412H86.5984C86.9094 185.414 87.2159 185.338 87.489 185.189C87.7862 185.027 88.0344 184.788 88.2076 184.498C88.3808 184.207 88.4726 183.875 88.4734 183.537V172.697C88.4733 172.437 88.4191 172.179 88.3142 171.941C88.2093 171.703 88.056 171.489 87.864 171.314Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_bd_8452_445316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.473,
    y: 63.6323,
    width: 43.0189,
    height: 43.0189,
    rx: 21.5094,
    fill: "#5290EC",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.973,
    y: 64.1323,
    width: 42.0189,
    height: 42.0189,
    rx: 21.0094,
    stroke: "url(#paint6_linear_8452_445316)",
    strokeOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.294 77.623C150.136 76.2853 148.834 75.0782 147.413 74.023C147.286 73.9355 147.136 73.8887 146.982 73.8887C146.828 73.8887 146.677 73.9355 146.551 74.023C145.13 75.0782 143.828 76.2853 142.669 77.623C140.091 80.5761 138.732 83.698 138.732 86.6418C138.732 88.8298 139.601 90.9282 141.148 92.4754C142.695 94.0226 144.794 94.8918 146.982 94.8918C149.17 94.8918 151.268 94.0226 152.816 92.4754C154.363 90.9282 155.232 88.8298 155.232 86.6418C155.232 83.698 153.873 80.5761 151.294 77.623ZM152.157 87.523C151.975 88.5947 151.464 89.5832 150.694 90.351C149.925 91.1189 148.935 91.6279 147.863 91.8074H147.741C147.552 91.8083 147.37 91.7379 147.231 91.6102C147.091 91.4824 147.005 91.3069 146.99 91.1185C146.975 90.9302 147.031 90.7429 147.148 90.5943C147.264 90.4457 147.433 90.3465 147.619 90.3168C148.384 90.1888 149.089 89.8256 149.637 89.2777C150.185 88.7299 150.548 88.0247 150.676 87.2605C150.693 87.1631 150.729 87.07 150.782 86.9866C150.835 86.9032 150.904 86.8311 150.985 86.7745C151.066 86.7179 151.157 86.6778 151.254 86.6567C151.35 86.6355 151.45 86.6336 151.548 86.6511C151.646 86.6669 151.739 86.7022 151.823 86.7549C151.907 86.8077 151.98 86.8767 152.037 86.9581C152.094 87.0394 152.134 87.1313 152.154 87.2283C152.175 87.3254 152.176 87.4256 152.157 87.523Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_bd_8452_445316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.718,
    y: 288.585,
    width: 43.0189,
    height: 43.0189,
    rx: 21.5094,
    fill: "#EC6152",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.218,
    y: 289.085,
    width: 42.0189,
    height: 42.0189,
    rx: 21.0094,
    stroke: "url(#paint7_linear_8452_445316)",
    strokeOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.102 302.969C143.583 302.969 143.075 303.123 142.644 303.412C142.212 303.7 141.876 304.11 141.677 304.59C141.478 305.07 141.426 305.597 141.528 306.107C141.629 306.616 141.879 307.084 142.246 307.451C142.613 307.818 143.081 308.068 143.59 308.169C144.099 308.27 144.627 308.218 145.107 308.02C145.586 307.821 145.996 307.485 146.285 307.053C146.573 306.621 146.727 306.114 146.727 305.594C146.725 304.899 146.447 304.233 145.956 303.741C145.464 303.249 144.798 302.972 144.102 302.969ZM144.102 306.719C143.88 306.719 143.662 306.654 143.477 306.53C143.292 306.406 143.148 306.231 143.063 306.025C142.978 305.819 142.955 305.593 142.999 305.375C143.042 305.157 143.149 304.956 143.307 304.799C143.464 304.642 143.664 304.535 143.883 304.491C144.101 304.448 144.327 304.47 144.533 304.555C144.738 304.64 144.914 304.784 145.038 304.969C145.161 305.154 145.227 305.372 145.227 305.594C145.227 305.893 145.109 306.179 144.898 306.39C144.687 306.601 144.4 306.719 144.102 306.719ZM139.227 311.529V302.594C139.227 301.6 138.832 300.646 138.129 299.943C137.425 299.24 136.472 298.844 135.477 298.844C134.483 298.844 133.529 299.24 132.825 299.943C132.122 300.646 131.727 301.6 131.727 302.594V311.529C131.135 312.054 130.661 312.699 130.338 313.422C130.014 314.145 129.849 314.928 129.852 315.719C129.852 317.211 130.445 318.642 131.5 319.697C132.555 320.752 133.985 321.344 135.477 321.344C136.969 321.344 138.4 320.752 139.455 319.697C140.509 318.642 141.102 317.211 141.102 315.719C141.105 314.928 140.94 314.145 140.617 313.422C140.293 312.699 139.82 312.054 139.227 311.529ZM135.477 300.344C136.073 300.347 136.644 300.585 137.065 301.006C137.487 301.428 137.725 301.999 137.727 302.594V305.594H133.227V302.594C133.23 301.999 133.467 301.428 133.889 301.006C134.31 300.585 134.881 300.347 135.477 300.344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_8452_445316",
    x: 217.02,
    y: 281.377,
    width: 64.2642,
    height: 66.2642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8452_445316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.294118 0 0 0 0 0.305882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_8452_445316",
    result: "effect2_dropShadow_8452_445316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8452_445316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_8452_445316",
    x: 256.726,
    y: 191.632,
    width: 95.981,
    height: 108.481,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8452_445316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.294118 0 0 0 0 0.305882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_8452_445316",
    result: "effect2_dropShadow_8452_445316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8452_445316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_8452_445316",
    x: 33.293,
    y: 216.268,
    width: 66.0566,
    height: 68.5566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8452_445316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.294118 0 0 0 0 0.305882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_8452_445316",
    result: "effect2_dropShadow_8452_445316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8452_445316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_8452_445316",
    x: 250.661,
    y: 98.2358,
    width: 83.019,
    height: 87.0188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8452_445316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.294118 0 0 0 0 0.305882 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_8452_445316",
    result: "effect2_dropShadow_8452_445316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8452_445316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bd_8452_445316",
    x: 222.396,
    y: 53.7358,
    width: 64.2642,
    height: 66.2642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8452_445316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.294118 0 0 0 0 0.305882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_8452_445316",
    result: "effect2_dropShadow_8452_445316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8452_445316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bd_8452_445316",
    x: 28.3364,
    y: 134.643,
    width: 97.7734,
    height: 108.405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.31579
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8452_445316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.294118 0 0 0 0 0.305882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_8452_445316",
    result: "effect2_dropShadow_8452_445316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8452_445316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_bd_8452_445316",
    x: 105.473,
    y: 51.6323,
    width: 83.019,
    height: 87.0188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8452_445316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.294118 0 0 0 0 0.305882 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_8452_445316",
    result: "effect2_dropShadow_8452_445316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8452_445316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_bd_8452_445316",
    x: 94.7178,
    y: 276.585,
    width: 83.019,
    height: 87.0188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8452_445316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.294118 0 0 0 0 0.305882 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_8452_445316",
    result: "effect2_dropShadow_8452_445316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8452_445316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8452_445316",
    x1: 233.02,
    y1: 289.033,
    x2: 266.628,
    y2: 321.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8452_445316",
    x1: 278.726,
    y1: 203.966,
    x2: 332.873,
    y2: 255.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8452_445316",
    x1: 49.293,
    y1: 224.349,
    x2: 84.7686,
    y2: 258.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8452_445316",
    x1: 270.661,
    y1: 108.443,
    x2: 315.472,
    y2: 151.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8452_445316",
    x1: 238.396,
    y1: 61.3915,
    x2: 272.004,
    y2: 93.6556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8452_445316",
    x1: 50.3364,
    y1: 145.034,
    x2: 106.351,
    y2: 198.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8452_445316",
    x1: 125.473,
    y1: 61.8399,
    x2: 170.284,
    y2: 104.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8452_445316",
    x1: 114.718,
    y1: 286.793,
    x2: 159.529,
    y2: 329.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeComingSoon);
export default __webpack_public_path__ + "static/media/home-coming-soon.54616c19cb2ae946174efaaa0cc3306d.svg";
export { ForwardRef as ReactComponent };